<template lang="pug">
  BCheckbox#terms-and-conditions(
    :value="termsAccepted"
    @input="setTermsAccepted"
    size="is-medium"
    v-validate="'required'"
    name="terms and conditions"
  ).has-text-grey.is-size-6
    span I confirm that I have read and agree to Be Well's
    span.pl-2
      //-TO DO: update this cloud services agreement link to TB
      a.has-text-grey-dark.has-text-underlined(href="https://walkertracker.com/walker-tracker-cloud-services-agreement/" target="_blank") Cloud Service's Agreement
    span.pl-2 and
    span.pl-2
      a.has-text-grey-dark.has-text-underlined(href="https://www.terryberry.com/privacy-policy/" target="_blank") Privacy Policy.

</template>

<script>
import WtButton from "@@/WtButton/WtButton";

export default {
  name: "TermsAndConditions",

  components: { WtButton },

  data() {
    return {
      termsAccepted: false
    };
  },

  methods: {
    setTermsAccepted(value) {
      this.termsAccepted = value;
      this.$emit("acceptTerms", value);
    }
  }
};
</script>

<style scoped lang="sass"></style>
